import { all, any, compose, filter, includes, keys, not } from 'ramda';
import { isNilOrEmptyString } from 'ramda-extension';

import { allowedSearchCombination } from './constants';

export const checkAllowedSearchCombinations = compose(
	// checks if keys are allowed combination
	(formKeys) => any(all((key) => includes(key, formKeys)))(allowedSearchCombination),
	// returns array of form field keys that are not empty
	compose(keys, filter(compose(not, isNilOrEmptyString))),
);
